module.exports = __webpack_public_path__ + "static/media/player-movein.5069ee94.ogg";